import {StyleSheet} from 'react-native';

import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

import color from './competency.color';

export const iconColor = StyleSheet.create({
  [COACH]: {
    color: color[COACH].primaryLighter,
  },
  [BUSINESS_COACH]: {
    color: color[BUSINESS_COACH].primaryLighter,
  },
  [BUSINESS_LEADER]: {
    color: color[BUSINESS_LEADER].primaryLighter,
  },
});
